import React, { createContext, useContext, useCallback, useState } from 'react';

const ToastContext = createContext(null);

let idCounter = 0;

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const remove = useCallback((id) => {
    setToasts((list) => list.filter((t) => t.id !== id));
  }, []);

  const show = useCallback((message, { type = 'info', duration = 3500 } = {}) => {
    const id = ++idCounter;
    setToasts((list) => [...list, { id, message, type }]);
    if (duration > 0) {
      setTimeout(() => remove(id), duration);
    }
    return id;
  }, [remove]);

  const value = {
    show,
    success: (msg, opts) => show(msg, { ...(opts || {}), type: 'success' }),
    error: (msg, opts) => show(msg, { ...(opts || {}), type: 'error' }),
    warn: (msg, opts) => show(msg, { ...(opts || {}), type: 'warning' }),
    info: (msg, opts) => show(msg, { ...(opts || {}), type: 'info' }),
    remove,
    toasts,
  };

  return (
    <ToastContext.Provider value={value}>
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within a ToastProvider');
  return ctx;
};


